import { render, staticRenderFns } from "./scrolldown.vue?vue&type=template&id=44672e47&scoped=true&"
import script from "./scrolldown.vue?vue&type=script&lang=js&"
export * from "./scrolldown.vue?vue&type=script&lang=js&"
import style0 from "./scrolldown.vue?vue&type=style&index=0&id=44672e47&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44672e47",
  null
  
)

export default component.exports